import { type MaybeRefOrGetter, ref, toValue } from 'vue'

import type { ContentCard } from '../PersonalizedFeed.utils'

export function useActiveTabIndex(
  contentCards: MaybeRefOrGetter<ContentCard[]>,
) {
  const activeTabIndex = ref(0)

  const displayFallback = ref(false)

  function setActiveTabIndex(index: number) {
    if (index === activeTabIndex.value) return

    displayFallback.value = false
    activeTabIndex.value = index
  }

  function goToPreviousTab() {
    const newIndex = Math.max(activeTabIndex.value - 1, 0)
    setActiveTabIndex(newIndex)
  }

  function goToNextTab() {
    const newIndex = Math.min(
      activeTabIndex.value + 1,
      toValue(contentCards).length - 1,
    )
    setActiveTabIndex(newIndex)
  }

  return {
    activeTabIndex,
    displayFallback,
    setActiveTabIndex,
    goToPreviousTab,
    goToNextTab,
  }
}
